/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import { RadioGroupComponent } from '../../../../Display/Claim/component/SelectClaim/SelectClaimSearchComponent';
import { NDCDetailsTextFieldComponent } from '../../../../Display/NDC/component/NDCDetails/NDCDetailsHeaderDetailsComponent';
import {
  addRowToTableData,
  checkTargetQtrIsFuture,
  dispatchNewUraRec,
  getRequestDrugPriceLoadDetails,
  savePriceLoadDetails,
  setPriceLoadDetailsChanged,
  setPriceLoadDetailsFilter,
  setPriceLoadDetailsTableData,
  validateNDCAvailability,
} from '../../store/action';
import {
  dataContentRadioData,
  dataSourceRadioData,
  multiPriceSelectionRadioData,
  PRODUCT_CODE_SIZE,
  PACKAGE_SIZE_ERROR,
  TARGET_QUARTER_ERROR,
  VALID_QUARTER_ERROR,
  FUTURE_QUARTER_ERROR,
  TABLE_ROW_ERROR,
} from '../../utils/constant';
import { checkQuaterIsValid } from '../RequestDrugPriceLoadManufactureTable';
import { resetMaintainPage } from '../../../../Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import {
  FAILED_MESSAGE_GENERIC,
  SUCCESSMESSAGE_GENERIC,
} from '../../../../../SharedModules/Errors/constantMessageData';
import NDCAvailabilityPopup from './NDCAvailabilityPopup';
import {
  closeTab,
  convertQuaterFromDate,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { getUTCTimeStampMMDDYYYY } from '../../../../../SharedModules/DateUtilities/DateUtilities';

/* This component is user for displaying  the details of the Drug Proce Load  */
const RequestDrugPriceLoadDetailsHeader = ({
  filters,
  tableData,
  successMessages,
  setErrorMessages,
  setSuccessMessages,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const priceLoadDetailsChanged = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsChanged
  );
  const upload_save_disable = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.upload_save_disable
  );
  const priceLoadDetailsLoaded = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsLoaded
  );
  const addURA = useSelector(
    (state) => state.sharedState.requestDrugPriceLoad.addURA
  );
  const [ndcDialog, setNDCDialog] = useState({
    open: false,
    mainData: [],
    tableData: [],
  });
  const [actionModal, setActionModal] = useState({ open: false, type: null });
  const [clostThisTab, setClostThisTab] = useState(false);
  const [labeler, setLabeler] = useState([]);
  const labelerTemp = [];
  const openActionModal = (type) => {
    setActionModal({ open: true, type });
  };

  const handleActionModalClose = () => {
    setActionModal({ open: false, type: null });
  };

  const handleNDCDialogClose = () => {
    setNDCDialog({
      open: false,
      mainData: [],
      tableData: [],
    });
  };
  /* Validate Existing NDC in data base */
  const checkNDCAvaialbleInDB = async (tableData) => {
    const data = _.uniqWith(
      tableData,
      (a, b) =>
        a.labelerCode === b.labelerCode &&
        a.packageSize === b.packageSize &&
        a.productCode === b.productCode
    ).map(({ labelerCode, packageSize, productCode, ...rest }) => {
      return { labelerCode, packageSize, productCode };
    });

    const response = await validateNDCAvailability(data);

    return response;
  };

  useEffect(() => {
    if (!priceLoadDetailsLoaded && !priceLoadDetailsChanged) {
      dispatch(getRequestDrugPriceLoadDetails(filters));
    }
  }, []);

  useEffect(() => {
    if (clostThisTab) {
      closeTab('/RequestDrugPriceLoadDetails', history);
    }
  }, [tableData]);

  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/RequestDrugPriceLoadDetails') {
          if (priceLoadDetailsChanged) {
            item.isFormDirty = true;
          } else {
            item.isFormDirty = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [priceLoadDetailsChanged]);

  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/RequestDrugPriceLoadDetails' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/RequestDrugPriceLoadDetails' && item.isFormSave) {
          item.isFormSave = false;
          setClostThisTab(true);
          onSave();
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  /* This method validate all the data entered by the user and 
  save the details in database on click of Save button */
  const onSave = async () => {
    setErrorMessages([]);
    setSuccessMessages([]);
    let localTableData = [];
    let allData = [];
    let priceData = [];
    let uraData = [];

    if (filters.dataContent === 'Multiple'){
      const productOrSizeCheckPrice = tableData?.priceTableData?.filter(
        (item) =>
          (item.productCode || item.packageSize) &&
          !item.deleteRecord
      );

      if(productOrSizeCheckPrice.length > 0){
          priceData = (tableData && tableData.priceTableData) || [];
          allData.push(...((tableData && tableData.priceTableData) || []));
      }
      const productOrSizeCheckURA =  tableData?.uraTableData?.filter(
        (item) =>
          (item.productCode || item.packageSize) &&
          !item.deleteRecord
      );

      if(productOrSizeCheckURA.length > 0){
        uraData = (tableData && tableData.uraTableData) || [];
        allData.push(...((tableData && tableData.uraTableData) || []));   
      }
      
    }else{
      priceData = (tableData && tableData.priceTableData) || [];
      allData.push(...((tableData && tableData.priceTableData) || []));
      uraData = (tableData && tableData.uraTableData) || [];
      allData.push(...((tableData && tableData.uraTableData) || []));
    }

    if (filters.multiPriceSelection === multiPriceSelectionRadioData[0].value) {
      localTableData = (tableData && tableData.priceTableData) || [];
    } else {
      localTableData = (tableData && tableData.uraTableData) || [];
    }

    const localErrorMessages = [];

    if (allData.length > 0) {
      const productCodeError = allData.filter(
        (item) =>
          (!item.productCode || item.productCode.length !== 4) &&
          !item.deleteRecord
      );

      const packageSizeError = allData.filter(
        (item) =>
          (!item.packageSize || item.packageSize.length !== 2) &&
          !item.deleteRecord
      );

      const emptyTargetQuaterError = allData.filter(
        (item) => !item.targetQtr && !item.deleteRecord
      );

      const qtrFomatError = allData.filter(
        (item) => item.targetQtr && !checkQuaterIsValid(item.targetQtr)
      );

      const futureQtrError = allData.filter(
        (item) =>
          item.targetQtr &&
          checkQuaterIsValid(item.targetQtr) &&
          checkTargetQtrIsFuture(item.targetQtr, filters.calcQtr) &&
          !item.deleteRecord
      );

      if (productCodeError.length > 0) {
        localErrorMessages.push(PRODUCT_CODE_SIZE);
      }

      if (packageSizeError.length > 0) {
        localErrorMessages.push(PACKAGE_SIZE_ERROR);
      }

      if (emptyTargetQuaterError.length > 0) {
        localErrorMessages.push(TARGET_QUARTER_ERROR);
      }

      if (qtrFomatError.length > 0) {
        localErrorMessages.push(VALID_QUARTER_ERROR);
      }

      if (futureQtrError.length > 0) {
        localErrorMessages.push(FUTURE_QUARTER_ERROR);
      }
    } else {
      localErrorMessages.push(TABLE_ROW_ERROR);
    }

    if (localErrorMessages.length > 0) {
      setErrorMessages(localErrorMessages);
    } else {
      const priceDubObj = {};
      const uraDubObj = {};

      priceData
        .filter((item) => !item.deleteRecord)
        .forEach((item) => {
          const ndcQtr = `${item.labelerCode}-${item.productCode}-${item.packageSize}/${item.targetQtr}`;
          if (priceDubObj[ndcQtr] === undefined) {
            priceDubObj[ndcQtr] = 1;
          } else {
            priceDubObj[ndcQtr] = priceDubObj[ndcQtr] + 1;
          }
        });

      uraData
        .filter((item) => !item.deleteRecord)
        .forEach((item) => {
          const ndcQtr = `${item.labelerCode}-${item.productCode}-${item.packageSize}/${item.targetQtr}`;
          if (uraDubObj[ndcQtr] === undefined) {
            uraDubObj[ndcQtr] = 1;
          } else {
            uraDubObj[ndcQtr] = uraDubObj[ndcQtr] + 1;
          }
        });

      const priceFilterArr = Object.keys(priceDubObj).filter(
        (item) => priceDubObj[item] > 1
      );
      const uraFilterArr = Object.keys(uraDubObj).filter(
        (item) => uraDubObj[item] > 1
      );
      let filterArr = [];
      if (filters.multiPriceSelection == 'Price') {
        filterArr = [...priceFilterArr];
        // allData = priceData;
      } else if (filters.multiPriceSelection == 'URA') {
        // allData = uraData;
        uraFilterArr.forEach((item) => {
          if (!filterArr.includes(item)) {
            filterArr.push(item);
          }
        });
      }

      if (filterArr.length > 0) {
        localErrorMessages.push(
          `Duplicate entry found for the following NDC/Quarter - ${filterArr.join(
            ', '
          )}`
        );
        setErrorMessages(localErrorMessages);
      } else {
        setErrorMessages([]);

        let data = filters.dataContent === 'Single' ? priceData : allData;
        const response = await checkNDCAvaialbleInDB(data);
        data = data.map((val) => {
          val.isAddedFromUI = false;
          return val;
        });

        if (response !== null) {
          if (response.length > 0) {
            setNDCDialog({
              open: true,
              mainData: data?.map((item) => ({
                ...item,
                isAddedFromUI: response?.includes(
                  `${item.labelerCode}-${item.productCode}-${item.packageSize}`
                ),
              })),
              tableData: response.map((item) => ({ ndc: item })),
            });
          } else {
            saveRecordsToDB(data);
          }
        } else {
          setErrorMessages([FAILED_MESSAGE_GENERIC]);
        }
      }
    }
  };

  /** This method generate the Pay for the save and call the API* */
  const saveRecordsToDB = (saveRecord) => {
    setErrorMessages([]);
    setSuccessMessages([]);
    if (saveRecord.length > 0) {
      const request = saveRecord.map((item) => {
        labelerTemp.push(item.labelerCode);
        if (item.calcUra !== undefined) {
          return {
            dataContent: 'Multiple',
            priceSelection: 'U',
            mfgTypeCd:
              filters.planType === 'FD' || filters.planType === 'ST'
                ? 'G'
                : 'C',
            rpc: filters.rpc,
            targetQtr: item.targetQtr,
            labelerCd: item.labelerCode,
            newRecord: item.isAddedFromUI ?? false,
            ...(item.deleteRecord
              ? { deleteRecord: true }
              : { deleteRecord: false }),
            updateRecord: !!(!item.deleteRecord && !item.isAddedFromUI),
            calculatedUraVO: {
              calculatedUraId: {
                ...(item.drugSeqNum
                  ? { drugSeqNum: item.drugSeqNum }
                  : { drugSeqNum: null }),
                ...(item.contractSeqNum
                  ? { contractSeqNum: item.contractSeqNum }
                  : { contractSeqNum: null }),
                targetQtr: item.targetQtr,
                calcQtr: filters.calcQtr,
              },
              calcUra: item.calcUra,
              externalSourceInd: 1,
            },
            drugVO: {
              drugName: '** FROM PRICE **',
              labelerCode: item.labelerCode,
              productCode: item.productCode,
              packageSize: item.packageSize,
            },
            // priceTypeCd: "AMP",
            calcQtr: filters.calcQtr,
            // price: item.calcUra,
            drugCatCd: item.drugCatCd,
          };
        }
        return {
          dataContent: filters.dataContent,
          targetQtr: item.targetQtr,
          labelerCd: item.labelerCode,
          newRecord: item.isAddedFromUI ?? false,
          ...(item.deleteRecord
            ? { deleteRecord: true }
            : { deleteRecord: false }),
          updateRecord: !!(!item.deleteRecord && !item.isAddedFromUI),
          rpc: filters.rpc,
          priceSelection: 'P',
          drugVO: {
            drugName: '** FROM PRICE **',
            ...(item.drugSeqNum ? { drugSeqNum: item.drugSeqNum } : {}),
            labelerCode: item.labelerCode,
            productCode: item.productCode,
            packageSize: item.packageSize,
          },
          priceTypeCdList: ['AMP', 'BP'],
          priceVO: {
            oldDrugSeqNum: item?.oldDrugSeqNum
              ? item?.oldDrugSeqNum
              : item.drugSeqNum,
            oldPriceTypeCd: item?.oldPriceTypeCd
              ? item?.oldPriceTypeCd
              : filters.priceType || 'AMP',
            oldStartDt: item?.oldStartDt
              ? item?.oldStartDt
              : convertQuaterFromDate(item.targetQtr),
            oldTargetQtr: item?.oldTargetQtr
              ? item?.oldTargetQtr
              : item.targetQtr,
            bestPrice: item?.bestPrice,
            priceId: {
              ...(item.drugSeqNum ? { drugSeqNum: item.drugSeqNum } : {}),
              targetQtr: item.targetQtr,
              priceTypeCd: filters.priceType || 'AMP',
              startDt: convertQuaterFromDate(item.targetQtr),
            },
            targetQtr: item.targetQtr,
            priceTypeCd: filters.priceType || 'AMP',
            priceTypeCdList: ['AMP', 'BP'],
            startDt: convertQuaterFromDate(item.targetQtr),
            calcQtr: filters.calcQtr,
            price: item.price,
            ...(filters.dataContent === dataContentRadioData[1].value &&
            filters.multiPriceSelection ===
              multiPriceSelectionRadioData[0].value
              ? { bestPrice: item.bestPrice }
              : {}),
            drugCatCd: item.drugCatCd,
          },
        };
      });
      const payload = { ...filters, lablecode: labelerTemp };
      dispatch(setPriceLoadDetailsChanged(false));
      dispatch(
        savePriceLoadDetails(
          request,
          payload,
          (res) => {
            setSuccessMessages([res]);
          },
          (error) => {
            setErrorMessages([
              error?.response?.data?.message || FAILED_MESSAGE_GENERIC,
            ]);
          }
        )
      );
    }
    setLabeler(labelerTemp);
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const addURAData = () => {
    let data = {
      isAddedFromUI: true,
      calcUra: '0.000000',
      lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
      lastUpdateUserId: logInUser,
      targetQtr: filters.calcQtr,
      calcQtr: filters.calcQtr,
      labelerCode: filters.mfgId,
      productCode: null,
      packageSize: null,
      index: 0,
      ccCommentsExist: 0,
      corrLinkId: 'new',
    };
    dispatch(addRowToTableData(data, 'URA'));
  };

  return (
    <>
      <div className="row mt-3">
        <div className="col-12">
          <fieldset className="custom-fieldset">
            <div className="p-0 mt-2 row">
              <div className="col-4">
                <NDCDetailsTextFieldComponent
                  label="Rebate Program"
                  value={filters && filters.rpc}
                  className="ml-0 mb-0"
                />
              </div>
              <div className="col-4">
                <NDCDetailsTextFieldComponent
                  label="Calculated Quarter"
                  value={filters && filters.calcQtr}
                  className="ml-0 mb-0"
                />
              </div>
              {filters?.dataContent === dataContentRadioData?.[0]?.value && (
                <div className="col-4">
                  <NDCDetailsTextFieldComponent
                    label="Price Type"
                    value={filters && filters.priceType}
                    className="ml-0 mb-0"
                  />
                </div>
              )}
            </div>
          </fieldset>
        </div>
      </div>
      <div className="row mt-2">
        {filters && filters.dataContent === dataContentRadioData[1].value && (
          <div className="col-6">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Multiple Price Selection
              </legend>
              <div className="p-0 mt-2 row">
                <div className="mui-custom-form col-12 m-0">
                  <RadioGroupComponent
                    data={multiPriceSelectionRadioData}
                    value={filters.multiPriceSelection}
                    onChange={(_, value) => {
                      dispatch(
                        setPriceLoadDetailsFilter({
                          ...filters,
                          multiPriceSelection: value,
                        })
                      );
                      if (value === 'URA' && addURA) {
                        addURAData();
                        dispatch(dispatchNewUraRec(false));
                      }
                    }}
                  />
                </div>
              </div>
            </fieldset>
          </div>
        )}
        <div
          className={`col-${
            filters && filters?.dataContent === dataContentRadioData?.[1]?.value
              ? '6'
              : '12'
          } d-flex justify-content-end align-items-center btn-wrapper`}
        >
          <Button
            className="btn btn-success btn-search"
            disabled={
              filters?.dataSource === dataSourceRadioData?.[2]?.value &&
              successMessages[0] !== SUCCESSMESSAGE_GENERIC
                ? upload_save_disable
                : !priceLoadDetailsChanged
            }
            onClick={() =>{
              setErrorMessages([])
               openActionModal('Save')}}
          >
            <SVGComponent iconName="Icon-awesome-save" />
            Save
          </Button>
          <Button
            disabled={!priceLoadDetailsChanged}
            onClick={() => 
            {  setErrorMessages([])
              openActionModal('Cancel')}}
            className="btn btn-cancel btn btn-primary"
          >
            <SVGComponent iconName="Icon-cancel" />
            Cancel
          </Button>
        </div>
      </div>
      <NDCAvailabilityPopup
        ndcDialog={ndcDialog}
        onConfirmClick={(mainData, tableData, selected) => {
          const filterData = tableData
            .filter((item) => !selected.includes(item.ndc))
            .map((item) => item.ndc);

          const filterRequest = mainData.filter((item) => {
            if (
              !filterData.includes(
                `${item.labelerCode}-${item.productCode}-${item.packageSize}`
              )
            ) {
              return item;
            }
          });

          handleNDCDialogClose();
          saveRecordsToDB(filterRequest);
        }}
        handleClose={handleNDCDialogClose}
        onNoClick={(mainData, tableData) => {
          const filterData = tableData.map((item) => item.ndc);

          const filterRequest = mainData.filter((item) => {
            if (
              !filterData.includes(
                `${item.labelerCode}-${item.productCode}-${item.packageSize}`
              )
            ) {
              return item;
            }
          });

          handleNDCDialogClose();
          saveRecordsToDB(filterRequest);
        }}
      />
      <SaveCancelPopup
        open={actionModal.open}
        title={actionModal.type}
        onConfim={() => {
          setErrorMessages([]);
          if (actionModal.type === 'Save') {
            onSave();
            handleActionModalClose();
          } else {
            dispatch(getRequestDrugPriceLoadDetails(filters));
            handleActionModalClose();
          }
        }}
        onCancel={handleActionModalClose}
        moduleName=""
      />
    </>
  );
};

export default RequestDrugPriceLoadDetailsHeader;
